"use client";
import Link from "@workspace/casino_pages/legacyLayer/client/components/Link";
import Translation from "@workspace/casino_pages/legacyLayer/client/components/Translation";
import Button from "@workspace/casino_pages/legacyLayer/legacyUi/Button";
import getThemeClassName from "@workspace/casino_pages/legacyLayer/shared/utils/getThemeClassName";
import Content from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/DataSolutionsNotification/Content";
import useDataSolutionsNotification from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/DataSolutionsNotification/useDataSolutionsNotification";
import handleMarkAsRead from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/graphql/handleMarkAsRead";

const DataSolutionsNotification: FC<NotificationViewProps> = ({
  notification,
  context,
  onClose,
}) => {
  const { translations, title, body, link, action } =
    useDataSolutionsNotification(notification);
  if (!translations) {
    return null;
  }
  const handleClose = () => {
    handleMarkAsRead(notification.data);
    onClose();
  };
  return (
    <div
      data-testid="data-solutions-notification"
      className={getThemeClassName(context.site, "light")}
    >
      <Content onClose={handleClose}>
        <div className="grid grid-flow-col grid-cols-[1fr_auto] items-center gap-3 pt-6 text-left">
          <div className="grid gap-4">
            <h4 className="text-lg/6 font-medium text-black">
              <Translation translations={translations} id={title} />
            </h4>
            <p className="text-sm/6">
              <Translation translations={translations} id={body} />
            </p>
            {link && (
              <Link href={link}>
                <Button fullWidth>
                  <Translation translations={translations} id={action} />
                </Button>
              </Link>
            )}
          </div>
        </div>
      </Content>
    </div>
  );
};

export default DataSolutionsNotification;
